import axios from 'axios';
import { BASE_URL, BASIC_AUTH } from 'src/config';
import { GetAuthorization } from 'src/utils/localStorage';
import API_URL from './api-url';

const isHandlerEnabled = false;

const requestHandler = (request) => {
  request.headers.common['Accept'] = 'application/json, text/javascript, */*; q=0.01';
  request.headers.common['Content-Type'] = 'application/json; charset=utf-8';
  request.headers.common['Access-Control-Allow-Origin'] = '*';

  if (request.url === API_URL.TOKEN) {
    request.headers.common['Authorization'] = BASIC_AUTH;
  } else {
    const authorization = GetAuthorization();
    request.headers.common['Authorization'] = authorization ? authorization : BASIC_AUTH;
  }

  return request;
};

const successHandler = (response, isHandlerEnabled) => {
  if (isHandlerEnabled) {
    console.info('Response success:', response);
  }

  return response;
};

const errorHandler = (error, isHandlerEnabled) => {
  if (isHandlerEnabled) {
    console.error('Response error', error);
  }

  const exceptionHandler = {
    error: 'server_error',
    error_description: 'An error has occurred, please contact the admin!'
  };

  return Promise.reject({
    ...(error && error.response && error.response.data ? error.response.data : exceptionHandler)
  });
};

export default class Service {
  constructor(namespace) {
    this.namespace = namespace;
    this.axios = axios.create({
      baseURL: BASE_URL,
      responseType: 'json'
    });

    //Enable request interceptor
    this.axios.interceptors.request.use(
      (request) => requestHandler(request, isHandlerEnabled),
      (error) => errorHandler(error, isHandlerEnabled)
    );

    //Response and Error handler
    this.axios.interceptors.response.use(
      (response) => successHandler(response, isHandlerEnabled),
      (error) => errorHandler(error, isHandlerEnabled)
    );
  }

  /**
   * Get Http Request
   * @param {any} action
   * @param {any} params
   */
  get(action, params) {
    return new Promise((resolve, reject) => {
      this.axios
        .request(params ? action + '?' + params : action, {
          method: 'GET'
        })
        .then((response) => {
          if (response && response.data) resolve(response.data);
          else reject(response);
        })
        .catch((error) => {
          if (error && error.response && error.response.data && error.response.data.error) {
            reject(error.response.data.error);
          } else reject(error);
        });
    });
  }

  /**
   * Post Http Request
   * @param {any} action
   * @param {any} requestBody
   * @param {any} params
   */
  post(action, requestBody, params = null) {
    return new Promise((resolve, reject) => {
      this.axios
        .request(params ? action + '?' + params : action, {
          method: 'POST',
          data: requestBody
        })
        .then((response) => {
          if (response && response.data) resolve(response.data);
          else reject(response);
        })
        .catch((error) => {
          if (error && error.response && error.response.data && error.response.data.error) {
            reject(error.response.data.error);
          } else reject(error);
        });
    });
  }

  /**
   * Put Http Request
   * @param {any} action
   * @param {any} requestBody
   * @param {any} params
   */
  put(action, requestBody, params = null) {
    return new Promise((resolve, reject) => {
      this.axios
        .request(params ? action + '?' + params : action, {
          method: 'PUT',
          data: requestBody
        })
        .then((response) => {
          if (response && response.data) resolve(response.data);
          else reject(response);
        })
        .catch((error) => {
          if (error && error.response && error.response.data && error.response.data.error) {
            reject(error.response.data.error);
          } else reject(error);
        });
    });
  }

  /**
   *Delete Http Request
   * @param {any} action
   * @param {any} params
   */
  delete(action, params = null) {
    return new Promise((resolve, reject) => {
      this.axios
        .request(params ? action + '?' + params : action, {
          method: 'DELETE'
        })
        .then((response) => {
          if (response && response.data) resolve(response.data);
          else reject(response);
        })
        .catch((error) => {
          if (error && error.response && error.response.data && error.response.data.error) {
            reject(error.response.data.error);
          } else reject(error);
        });
    });
  }
}
